import AltInstance from '../Globals/Scripts/AltInstance';
import ProfileApi from '../Apis/ProfileApi';
import ActionHelper from './ActionHelper';

class ProfileActions {
    constructor() {
        this.generateActions(
            'profileLoaded'
        );
    }

    async loadProfile() {
        var profile = await ActionHelper.executeRequestWithNoActionNotification(ProfileApi.loadProfile);
        this.profileLoaded(profile);
    }
}

export default AltInstance.createActions(ProfileActions);
